import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import ApplyTrade from "@/pages/ApplyTrade";
import EnquiryList from "@/pages/EnquiryList";
import Login from "@/pages/Login";

import RetailerCatalog from "@/pages/retailer/RetailerCatalog";
import Cart from "@/pages/retailer/Cart";
import Checkout from "@/pages/retailer/Checkout";
import Orders from "@/pages/retailer/Orders";
import PendingApproval from "@/pages/retailer/PendingApproval";
import RetailerAlerts from "@/pages/retailer/RetailerAlerts";

import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import SageIntegration from "@/pages/admin/SageIntegration";
import Inventory from "@/pages/admin/Inventory";
import AdminOrders from "@/pages/admin/AdminOrders";
import Reconciliation from "@/pages/admin/Reconciliation";
import Applications from "@/pages/admin/Applications";
import Settings from "@/pages/admin/Settings";
import Products from "@/pages/admin/Products";
import Notifications from "@/pages/admin/Notifications";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="top-right" theme="dark" richColors />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/product/:sku" element={<ProductDetail />} />
              <Route path="/apply" element={<ApplyTrade />} />
              <Route path="/enquiry" element={<EnquiryList />} />
              <Route path="/login" element={<Login />} />

              <Route path="/portal/pending" element={<ProtectedRoute><PendingApproval /></ProtectedRoute>} />
              <Route path="/portal" element={<ProtectedRoute role="retailer"><RetailerCatalog /></ProtectedRoute>} />
              <Route path="/portal/cart" element={<ProtectedRoute role="retailer"><Cart /></ProtectedRoute>} />
              <Route path="/portal/checkout" element={<ProtectedRoute role="retailer"><Checkout /></ProtectedRoute>} />
              <Route path="/portal/orders" element={<ProtectedRoute role="retailer"><Orders /></ProtectedRoute>} />
              <Route path="/portal/alerts" element={<ProtectedRoute role="retailer"><RetailerAlerts /></ProtectedRoute>} />

              <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="sage" element={<SageIntegration />} />
                <Route path="inventory" element={<Inventory />} />
                <Route path="products" element={<Products />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="reconciliation" element={<Reconciliation />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="applications" element={<Applications />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
